<template>
  <Menu v-if="owners_association" :owners_association="owners_association"></Menu>
</template>

<script>
import Menu from '@/components/Menu/Menu';

export default {
  components:
      {
        Menu,
      },
  computed:
      {
        owners_association() {
          return this.$store.getters.ownersAssociation;
        },
      },
  created() {
  },
};
</script>
